var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUpdateTechnicianStatusMutation } from '../../../../application/features/technicians/technician-api';
import useTranslate from '../../../../localization/helpers';
var DeActivateTechnicianDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, technician = _a.technician;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var _c = __read(useUpdateTechnicianStatusMutation(), 2), updateTechnicianStatus = _c[0], _d = _c[1], updateTechnicianStatusLoading = _d.isLoading, updateTechnicianStatusSuccess = _d.isSuccess;
    var _e = useForm({
        reValidateMode: 'onChange'
    }), reset = _e.reset, handleSubmit = _e.handleSubmit;
    useEffect(function () {
        reset({
            technicianId: technician.id,
            isActive: false
        });
    }, [reset, technician]);
    useEffect(function () {
        if (updateTechnicianStatusSuccess) {
            enqueueSnackbar(tWithField('toolTips.deactivateSuccess', 'common.technician'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClose, updateTechnicianStatusSuccess]);
    var onSubmit = function (request) { return updateTechnicianStatus(request); };
    return (_jsxs(Dialog, { open: isOpen, children: [_jsx(DialogTitle, { id: 'confirm-dialog-title', children: tWithFunction('actions.deactivateFunction', 'common.technician') }), _jsx(DialogContent, { children: _jsx(DialogContentText, { id: 'confirm-dialog-description', children: tWithFunction('technicians.statusConfirmText', 'common.deactivate') }) }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: updateTechnicianStatusLoading, variant: 'outlined', color: 'inherit', onClick: onClose, children: translate('actions.cancel') }), _jsx(Button, { disabled: updateTechnicianStatusLoading, onClick: handleSubmit(onSubmit), variant: 'contained', color: 'warning', children: translate('actions.confirm') })] })] }));
};
export default DeActivateTechnicianDialog;
